import { takeLatest } from 'redux-saga/effects';
import { signInSaga } from './saga';
import * as actionTypes from './actionTypes';

export default function* watchUserAuthentication() {
    yield takeLatest(actionTypes.SIGN_IN_USER, signInSaga);
}